/**
 * Dimming for legend hover: fade every series except the one being read.
 *
 * Sets the group opacity directly rather than using Highcharts' `inactive`
 * state, which these legends used to reach for. That state now carries a
 * different meaning — "this series has no point at the hovered date", faded
 * all the way out (`plotOptions.series.states.inactive` in
 * `useInitializeHighcharts`) — so reusing it here would make legend hover hide
 * the other series outright instead of dimming them.
 *
 * 0.2 is what the `inactive` state rendered before, so the legends look
 * exactly as they did. The sidebar legend dims to 0.15 through
 * `applySeriesHover`; the two differ only because neither was changed here.
 */
const LEGEND_DIM_OPACITY = 0.2

/** The part of a Highcharts series these helpers touch. Kept structural so
 * both the shared legend and Studio's own copy can pass their series through
 * without agreeing on a Highcharts type import. */
type DimmableSerie = { group?: { attr: (opts: object) => void } }

export function dimSerie(serie: DimmableSerie): void {
  serie.group?.attr({ opacity: LEGEND_DIM_OPACITY })
}

export function undimSerie(serie: DimmableSerie): void {
  serie.group?.attr({ opacity: 1 })
}
